import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "../Assets/Icons/closeIcon.svg";
import Form from "react-bootstrap/Form";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function EditProfileModal(props) {
  const notify = () => toast.success("Changes Saved");

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div style={{ paddingBottom: "1.5rem" }}>
        <div className="Edit-profile-modal-header">
          <p>Edit Profile</p>
          <img onClick={props.onHide} src={CloseIcon} />
        </div>
        <div className="edit-profile-modal-input-con">
          <Form.Group controlId="formBasic">
            <Form.Label style={{ color: "#27293D" }}>First Name</Form.Label>
            <Form.Control
              className="shadow-none"
              style={{ border: "1.6px solid #27293D" }}
              type="text"
              placeholder="First name"
            />
          </Form.Group>
          <Form.Group controlId="formBasic">
            <Form.Label style={{ color: "#27293D" }}>Last Name</Form.Label>
            <Form.Control
              className="shadow-none"
              style={{ border: "1.6px solid #27293D" }}
              type="text"
              placeholder="Last name"
            />
          </Form.Group>
          <Form.Group controlId="formBasicEmail">
            <Form.Label style={{ color: "#27293D" }}>Email</Form.Label>
            <Form.Control
              className="shadow-none"
              style={{ border: "1.6px solid #27293D" }}
              type="email"
              placeholder="info@email.com"
            />
          </Form.Group>
          <Form.Group controlId="formBasic">
            <Form.Label style={{ color: "#27293D" }}>Zip code</Form.Label>
            <Form.Control
              className="shadow-none"
              style={{ border: "1.6px solid #27293D" }}
              type="number"
              placeholder="zip code"
            />
          </Form.Group>
          <Form.Group controlId="formBasic">
            <Form.Label style={{ color: "#27293D" }}>Address</Form.Label>
            <Form.Control
              className="shadow-none"
              style={{ border: "1.6px solid #27293D" }}
              type="text"
              placeholder="Islamabad, Pakistan"
            />
          </Form.Group>
          <Form.Group controlId="formBasic">
            <Form.Label style={{ color: "#27293D" }}>Shop address</Form.Label>
            <Form.Control
              className="shadow-none"
              style={{ border: "1.6px solid #27293D" }}
              type="text"
              placeholder="Islamabad, Pakistan"
            />
          </Form.Group>
          <Form.Group controlId="formBasic">
            <Form.Label style={{ color: "#27293D" }}>Phone</Form.Label>
            <Form.Control
              className="shadow-none"
              style={{ border: "1.6px solid #27293D" }}
              type="number"
              placeholder="+923160598938"
            />
          </Form.Group>
        </div>
        <div className="edit-profile-modal-btns-con">
          <div className="edit-profile-modal-btns">
            <Button
              onClick={props.onHide}
              style={{ borderRadius: "2px" }}
              variant="outline-dark"
            >
              Cancel
            </Button>
            <Button
              onClick={notify}
              style={{ borderRadius: "2px", backgroundColor: "#008BD9" }}
              type="submit"
              variant="primary"
            >
              Save changes
            </Button>
            <ToastContainer
               variant='success'
              position="top-center"
              autoClose={5000}
              hideProgressBar
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
